import { render } from "./SidebarAppComponent.vue?vue&type=template&id=7125a94f&scoped=true"
import script from "./SidebarAppComponent.vue?vue&type=script&lang=js"
export * from "./SidebarAppComponent.vue?vue&type=script&lang=js"

import "./SidebarAppComponent.vue?vue&type=style&index=0&id=7125a94f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7125a94f"]])

export default __exports__